import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { MobileMenuIcon } from '../styles';

type Props = {
  className?: string;
  disabled?: boolean;
  exact?: boolean;
  extraContent?: ReactNode;
  handleClick?: () => void;
  href?: string;
  icon?: IconProp;
  label: ReactNode;
  openNewWindow?: boolean;
  to?: string;
};

export const MobileLink = (props: Props) => {
  if (props.disabled) {
    return null;
  }

  const linkContent = (
    <>
      {props.icon && <MobileMenuIcon fixedWidth icon={props.icon} aria-hidden="true" />}
      <span>{props.label}</span>
      {props.extraContent}
    </>
  );

  if (props.href) {
    return (
      <a
        href={props.href}
        target={props.openNewWindow ? '_blank' : undefined}
        rel={props.openNewWindow ? 'noopener noreferrer' : undefined}
        className={props.className}
      >
        {linkContent}
      </a>
    );
  }

  if (props.to) {
    return (
      <NavLink
        exact={props.exact}
        to={props.to}
        onClick={() => props.handleClick?.()}
        className={props.className}
        activeClassName="active"
      >
        {linkContent}
      </NavLink>
    );
  }

  return null;
};
